import { COMMITMENT_ONLY_LOG_TYPES } from './commitment-only-log-types.js';
import { VALUE_ONLY_LOG_TYPES } from './value-only-log-types.js';
/** A zero `change_qty` is expected on a row that revalues stock or moves only commitment, which unstaging zeroes rather than deletes. */
export const isExpectedZeroChange = (typeId) => VALUE_ONLY_LOG_TYPES.includes(typeId) || COMMITMENT_ONLY_LOG_TYPES.includes(typeId);
//# sourceMappingURL=is-expected-zero-change.js.map